import { memo, useEffect, useState } from "react";
import { DesignData } from "@constants/design-data";
import { ContractConst } from "@constants/contract-const";
import { PROGRESS_STATUS } from "@constants/inbound";

interface Props {
  data: any;
  className: string;
}

const Index = ({ data, className }: Props) => {
  const [parameterName, setParameterName] = useState("progressStatus");
  const [labelColor, setLabelColor] = useState("");

  const labelColorCheck = () => {
    if (!className) {
      switch (data.data[parameterName]?.value ? data.data[parameterName].code : data.data[parameterName]) {
        case DesignData.progressStatus.CONTRACT_COMPLETED:
        case DesignData.progressStatus.COMPLETED:
        case PROGRESS_STATUS.COMPLETED:
          setLabelColor("inline-block p-1.5 font-medium text-white bg-green-400 rounded"); // 녹색
          break;

        case PROGRESS_STATUS.CONSULTATION_COMPLETE:
        case PROGRESS_STATUS.CONSTRUCTION_COMPLETED:
        case PROGRESS_STATUS.CONTRACT_COMPLETED:
          setLabelColor("inline-block p-1.5 font-medium text-white bg-blue-600 rounded"); // 어두운 파란색
          break;
        case DesignData.progressStatus.DESIGNING_ESTIMATING:
        case DesignData.progressStatus.BUILDING:
        case ContractConst.progressStatus.REQUEST:
        case PROGRESS_STATUS.CONSULTING:
        case PROGRESS_STATUS.DESIGN_ESTIMATE:
        case PROGRESS_STATUS.CONTRACT:
        case PROGRESS_STATUS.CONSTRUCTION:
        case PROGRESS_STATUS.TRANSACTION_SETTLEMENT:
          setLabelColor("inline-block p-1.5 font-medium text-white bg-blue-400 rounded"); // 하늘색
          break;
        case PROGRESS_STATUS.CONSULTATION_REQUEST:
          setLabelColor("inline-block p-1.5 font-medium text-white bg-orange-400 rounded"); // 주황색완
          break;
        case ContractConst.progressStatus.COMPLETED:
        case PROGRESS_STATUS.PREPARATION:
          setLabelColor("inline-block p-1.5 font-medium text-white bg-gray-400 rounded"); // 회색
          break;
        case DesignData.progressStatus.STOPPED:
        case PROGRESS_STATUS.CONSULTATION_STOP:
          setLabelColor("inline-block p-1.5 font-medium text-white bg-gray-600 rounded"); // 어두운 회색
          break;
        case ContractConst.progressStatus.STOPPED:
          setLabelColor("inline-block p-1.5 font-medium text-white bg-red-400 rounded"); // 빨간색
          break;
        default:
          break;
      }
    } else {
      setLabelColor(className);
    }
    return labelColor;
  };

  useEffect(() => {
    labelColorCheck();
  }, [labelColor]);

  return (
    <>
      <button disabled={true} className={labelColor}>
        {data.data[parameterName]?.value ? data.data[parameterName].value : data.data[parameterName]}
      </button>
    </>
  );
};

export default memo(Index);
